<template>
  <div>
    <b-modal
      centered
      size="lg"
      :id="data.origin"
      hide-footer
      :title="`${isEdit ? 'Edição' : 'Cadastro'} de ${data.title}`"
      @hidden="resetInfo"
    >
      <b-container tag="form" @submit.prevent="submitForm(data.origin)">
        <b-row v-if="data.origin === 'domain'">
          <b-col cols="6" v-if="isAdmin">
            <app-select
              :data="{
                class: ['mt-15'],
                options: companies,
                valueDefault: 'Empresa',
                required: true,
              }"
              v-model="form.clientid"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <app-select
              :data="{
                class: ['mt-15'],
                options: optionsStatus,
                valueDefault: 'Status',
                required: true,
              }"
              v-model="form.status"
            />
            <!-- optionsStatus -->
          </b-col>
          <b-col cols="12">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Domain"
              maxlength="70"
              required
              v-model="form.primary"
              :disabled="isEdit"
            />
          </b-col>
        </b-row>
        <b-row v-if="data.origin === 'vips'">
          <b-col cols="6">
            <app-select
            v-if="isAdmin"
              :data="{
                class: ['mt-15'],
                options: companies,
                valueDefault: 'Empresa',
                required: true,
              }"
              v-model="form.clientid"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <app-select
              :data="{
                class: ['mt-15'],
                options: optionsStatus,
                valueDefault: 'Status',
                required: true,
              }"
              v-model="form.status"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Nome"
              maxlength="70"
              required
              v-model="form.name"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="email"
              class="form-control mt-15"
              placeholder="E-mail"
              maxlength="70"
              required
              v-model="form.email"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="tel"
              class="form-control mt-15"
              placeholder="CPF"
              maxlength="70"
              v-mask="'###.###.###-##'"
              v-model="form.cpf"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="tel"
              class="form-control mt-15"
              placeholder="RG"
              maxlength="70"
              v-model="form.registro_geral"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Linkedin"
              maxlength="70"
              v-model="form.linked_in"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Facebook"
              maxlength="70"
              v-model="form.facebook"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Instagram"
              maxlength="70"
              v-model="form.instagram"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Twitter"
              maxlength="70"
              v-model="form.twitter"
              :disabled="isEdit"
            />
          </b-col>
        </b-row>
        <b-row v-if="data.origin === 'string'">
          <b-col cols="6">
            <app-select
            v-if="isAdmin"
              :data="{
                class: ['mt-15'],
                options: companies,
                valueDefault: 'Empresa',
                required: true,
              }"
              v-model="form.clientid"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="6">
            <app-select
              :data="{
                class: ['mt-15'],
                options: optionsStatus,
                valueDefault: 'Status',
                required: true,
              }"
              v-model="form.status"
            />
          </b-col>
          <b-col cols="12">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Search String"
              maxlength="70"
              required
              v-model="form.searchstring"
              :disabled="isEdit"
            />
          </b-col>
          <b-col cols="12">
            <b-form-tags
              input-id="tags-basic"
              v-model="form.filters"
              placeholder="Filters"
              class="form-control mt-15"
              remove-on-delete
            ></b-form-tags>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-3 d-flex justify-content-end">
            <b-button
              variant="outline-warning"
              @click="$bvModal.hide(data.origin)"
            >
              <i class="fa fa-ban" aria-hidden="true"></i>
              Cancelar</b-button
            >
            <b-button variant="outline-primary" type="submit" class="ml-2">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>Salvar</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-card no-body class="mb-1 my-2">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-row no-gutters class="py-3">
          <b-col
            cols="1"
            class="d-flex justify-content-start pl-2"
            v-if="isTable"
          >
            <b-button
              v-b-toggle="data.origin"
              variant="outline-secondary"
              @click="isActive = !isActive"
            >
              <img
                src="@/assets/img/svgs/arrow-down.svg"
                height="20"
                v-if="!isActive"
              />
              <img
                src="@/assets/img/svgs/arrow-up.svg"
                height="20"
                v-if="isActive"
              />
            </b-button>
          </b-col>
          <b-col cols="4">
            <h4 class="f-default d-flex align-items-center h-100">
              {{ data.title }}
            </h4>
          </b-col>
          <b-col cols="6">
            <slot name="middle" />
          </b-col>
          <b-col
            cols="1"
            class="d-flex justify-content-end pr-2"
            v-if="data.isButton"
          >
            <b-button
              variant="outline-secondary"
              @click="$bvModal.show(data.origin)"
              ><img src="@/assets/img/svgs/add.svg" height="20"
            /></b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-collapse
        :id="data.origin"
        :accordion="data.origin"
        role="tabpanel"
        @click="$emit('id', data.origin)"
      >
        <b-card-body>
          <app-table
            v-if="isTable"
            :data-array="data.table.items"
            :fields="data.table.fields"
            :rows="rowsData"
            @keyword="$emit('keyword', { origin: data.origin, event: $event })"
            @perPage="$emit('perPage', { origin: data.origin, event: $event })"
            @currentPage="
              $emit('currentPage', { origin: data.origin, event: $event })
            "
          >
          <template v-slot:company="{data}">
            {{data.item.company.name}}
          </template>
            <template v-slot:status="{ data }">
              {{ data.item.status }}
            </template>
            <template v-slot:actions="{ data }">
                <button
                class="btn btn-sm btn-outline-primary btn-rounded"
                @click="enterRoute(data.item, 'one')"
                v-if="data.item.buttons.includes('AXUR_ONE')"
              >
                AXUR ONE
              </button>
                       <button
                class="btn btn-sm btn-outline-primary btn-rounded mx-1"
                @click="enterRoute(data.item, 'darkweb')"
                v-if="data.item.buttons.includes('DARK_WEB')"
              >
                DARK WEB
              </button>
              <button
                class="btn btn-sm btn-outline-primary btn-rounded"
                @click="enterRoute(data.item)"
                v-if="data.item.buttons.includes('save')"
              >
                Acessar
              </button>
              <button
                class="
                  btn btn-sm btn-outline-warning btn-rounded
                  mx-2
                  my-md-2 my-xl-0
                "
                @click="editInfo(data.item)"
                v-if="data.item.buttons.includes('edit')"
                :disabled="data.item.status.includes('scanning')"
              >
                Editar
              </button>
              <button
                class="btn btn-sm btn-outline-danger btn-rounded"
                @click="removeInfo(data.item)"
                v-if="data.item.buttons.includes('remove')"
                :disabled="data.item.status.includes('scanning')"

              >
                Remover
              </button>
            </template>
          </app-table>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import { mixins } from "@/mixins/mixins";
import Swal from "sweetalert2";

export default {
  props: {
    data: Object,
    companies: Array,
    optionsStatus: Array,
    rowsData: {
      type: Number,
      default: () => 0,
    },
    isTable: {
      type: Boolean,
      default: () => true,
    },
  },
  mixins: [mixins],
  data() {
    return {
      form: {},
      isAdmin: this.$store.getters["auth/isAdmin"],
      isActive: false,
      isEdit: false,
    };
  },

  methods: {
    submitForm() {
      if (!this.isEdit) {
        Object.assign(this.form, {
          origin: this.data.origin,
        });
      }
      this.$emit(this.isEdit ? "edit" : "submit", this.form);
    },

    enterRoute(data, origin='') {
      if (data.type !== "AXUR") {
        const id = data.id ? data.id : data.channelId;
        let clientId = undefined;
        if (data.clientId) {
          clientId = data.clientId;
        }
        if(data.clientid){
          clientId = data.clientid
        }
        if(data.client_id){
          clientId = data.client_id
        }
        if(data.route === 'vips'){
          clientId = data['company']['idCompany']
        }
        // const cliendid = data.clientId ? data.clientId : data.clientid;
        this.$router.replace(
          `/loki/details/${data.route}?id=${id}&client=${clientId}`
        );
      } else {
        let { company } = data;

        this.$router.replace(
          `/loki/details/${data.route}?id=${data.id}&type=${origin}&client=${company['idCompany']}`
        );
      }
    },
    editInfo(data) {
      if(data['company']){
        this.form = {
          ...data,
          clientid: data['company']['idCompany']
        };

      }else{
        this.form = data
      }
      this.$bvModal.show(data.route);
      this.isEdit = true;
    },
    resetInfo() {
      this.isEdit = false;
      this.form = {};
      this.$emit("reset", this.data.origin);
    },
    async removeInfo(data) {
      const swal = await Swal.fire({
        title: "Atenção !",
        text: "Você deseja realmente remover?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
      });
      if (swal.value) {
        this.$emit("remove", data);
      }
    },
  },
};
</script>